import React, { Component } from 'react';
import { connect } from 'shalala';
import { Col, Row } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../store';
import DashboardClientesList from './list/DashboardClientesList';
import DashboardClientesSearch from './components/DashboardClientesSearch';
import DashboardClientesDownload from './components/DashboardClientesDownload';

class DashboardClientes extends Component {
  state = {};

  componentDidMount() {
    window.setAppTitle('Dashboardss');
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/admin/dashboard/${data.cliente_id}/info`,
      state: {
        data: { ...data },
      },
    });
  };

  render() {
    const { from, to } = this.props.pagination;

    return (
      <>
        <Row className="mt-3">
          <Col
            sm="auto"
            md="8"
            className="mb-2"
          >
            <DashboardClientesSearch />
          </Col>

          {Guardian.allows('admin.dashboard.clientes.download') && (
            <Col className="text-right">
              <DashboardClientesDownload
                from={from}
                to={to}
              />
            </Col>
          )}
        </Row>

        <Row className="mt-3">
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
          >
            <DashboardClientesList onRowClick={this.handleOnRowClick} />
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return store.admin.dashboard.list;
};

const mapActions = (actions) => {
  return {
    paginate: actions.admin.dashboard.list.paginate,
  };
};

export default connect(useStore, mapState, mapActions)(DashboardClientes);
